import { RootState } from 'store/store';

export const selectIsAuth = (state: RootState): boolean => state.user.user.isAuth;
export const selectUserData = (state: RootState) => ({
  username: state.user.user.username,
  userRole: state.user.user.userRole,
  userId: state.user.user.userId,
});
export const selectAuthStatus = (state: RootState) => state.user.user.signInStatus;
export const selectAuthError = (state: RootState): string => state.user.user.error;

export const selectAccount = (state: RootState) => state.user.account.account;
export const selectAppData = (state: RootState) => state.user.appData.appData;

export const selectUpdateAccountPasswordStatus = (state: RootState): string => state.user.accountActions.updateAccountPasswordStatus;
export const selectUpdateAccountDataStatus = (state: RootState): string => state.user.accountActions.updateAccountDataStatus;
export const selectAccountActionsMessage = (state: RootState): string => state.user.accountActions.message;
export const selectAccountActionsError = (state: RootState): string => state.user.accountActions.error;

export const selectRequestResetPasswordStatus = (state: RootState): string => state.user.resetPassword.requestResetPasswordStatus;
export const selectValidateTokenStatus = (state: RootState): string => state.user.resetPassword.validateTokenStatus;
export const selectResetPasswordStatus = (state: RootState): string => state.user.resetPassword.resetPasswordStatus;
export const selectResetPasswordError = (state: RootState): string => state.user.resetPassword.error;
